<template>
    <b-card>
        <div class="table-header-container d-flex justify-content-between align-items-center pt-2 pb-3">
            <div class="title-container d-flex align-items-center">
                <h2 class="pr-1">{{title}}</h2>
            </div>


            <div class="d-flex justify-content-end">
                <b-button variant="secondary" class="btn-icon mr-1">
                    <feather-icon icon="Trash2Icon"/>
                </b-button>
                <b-button variant="secondary" class="btn-icon">
                    <feather-icon icon="ChevronUpIcon"/>
                </b-button>
            </div>

        </div>
        <b-table responsive="sm"
                 :fields="columns"
                 hover
                 fixed outlined
                 :items="rows">

            <template #cell(actions) td-class="text-right">
                <b-button variant="flat-secondary" class="btn-icon">
                    <feather-icon icon="Edit3Icon"/>
                </b-button>
                <b-button variant="flat-danger" class="btn-icon">
                    <feather-icon icon="Trash2Icon"/>
                </b-button>
            </template>
        </b-table>

        <div class="card-footer-container d-flex justify-content-between align-items-center pt-2 pb-1">
            <div class="title-container d-flex align-items-center">
                <span class="text-muted">სულ {{rows.length}} ვარიანტი</span>
            </div>

            <b-button variant="primary" class="">
                <feather-icon icon="PlusIcon"
                              class="mr-50"/>
                <span class="align-middle">ახალი ვარიანტი</span>
            </b-button>
        </div>

        <div class="analysis-container">
            <h5>სად უნდა აისახოს მოცემული კვლევის მეთოდი?</h5>
            <div class="d-flex align-items-center">
                <b-form-checkbox checked="true"
                                 class="custom-control-primary"
                                 name="check-button"
                                 switch>
                    <span class="switch-icon-left">
                        <feather-icon icon="CheckIcon"/>
                    </span>
                    <span class="switch-icon-right">
                        <feather-icon icon="XIcon"/>
                  </span>
                </b-form-checkbox>
                <span>ინდექს პაციენტის რეგისტრაციისას</span>
            </div>
            <div class="d-flex align-items-center">
                <b-form-checkbox checked="true"
                                 class="custom-control-primary"
                                 name="check-button"
                                 switch>
                    <span class="switch-icon-left">
                        <feather-icon icon="CheckIcon"/>
                    </span>
                    <span class="switch-icon-right">
                        <feather-icon icon="XIcon"/>
                  </span>
                </b-form-checkbox>
                <span>კონტაქტის TBI გამოკვლევებში</span>
            </div>
            <div class="d-flex align-items-center">
                <b-form-checkbox checked="false"
                                 class="custom-control-primary"
                                 name="check-button"
                                 switch>
                    <span class="switch-icon-left">
                        <feather-icon icon="CheckIcon"/>
                    </span>
                    <span class="switch-icon-right">
                        <feather-icon icon="XIcon"/>
                  </span>
                </b-form-checkbox>
                <span>კონტაქტის TB გამოკვლევებში</span>
            </div>
            <div class="d-flex align-items-center">
                <b-form-checkbox checked="true"
                                 class="custom-control-primary"
                                 name="check-button"
                                 switch>
                    <span class="switch-icon-left">
                        <feather-icon icon="CheckIcon"/>
                    </span>
                    <span class="switch-icon-right">
                        <feather-icon icon="XIcon"/>
                  </span>
                </b-form-checkbox>
                <span>რისკ-ჯგუფების გამოკვლევებში</span>
            </div>
        </div>

        <b-modal
                id="modal-login"
                cancel-variant="outline-secondary"
                ok-title="Login"
                cancel-title="Close"
                centered
                title="Login Form">
            <breadcrumb-slot :items="items" :modal="false"></breadcrumb-slot>
        </b-modal>
    </b-card>
</template>

<script>
    import {BCard, BTable, BButton, BFormCheckbox, BModal} from "bootstrap-vue"
    import BreadcrumbSlot from "../../components/breadcrumb/BreadcrumbSlot";

    export default {
        components: {
            BreadcrumbSlot,
            BCard,
            BTable,
            BButton,
            BFormCheckbox,
            BModal
        },
        props: ["rows", "title", "columns"],

        data() {
            return {
                pageLength: 3,
                dir: false,
                rowsData: [],
                searchTerm: "",
                items: [
                    {
                        text: "ინდექს პაციენტები",
                        active: true
                    }
                ],
                defaultFields: ["georgian", "english", "actions"],
                defaultRows: [
                    {
                        georgian: "არ აქვს",
                        english: "None",
                        default: "",
                        _rowVariant: "secondary"
                    },
                    {
                        id: 6,
                        georgian: "სხვა",
                        english: "Other",
                        default: "",
                        _rowVariant: "secondary"

                    }
                ],
            }
        },
    }
</script>

<style scoped>
    .hidden_header {
        display: none;
    }

    .card .table tbody tr:last-child td:first-child {
      font-weight: normal !important;
    }

    .table-responsive-sm .table td[aria-colindex='3'] {
        text-align: right;
    }

    .table-responsive-sm .table th[aria-colindex='3'] div {
        display: none;
    }

    .analysis-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 10px;
    }

    .analysis-container h5 {
        grid-column: 1 / span 2;
    }
</style>
